module.exports = __webpack_public_path__ + "media/002.3def81ec.mp3";